import { combineReducers, configureStore } from "@reduxjs/toolkit";

import applicationReducer from "./application";
import assetViewsReducer from "./assetViews";
import { bmcEolReducer } from "./bmc";
import languageReducer from "./language";
import licensesReducer from "./license";
import mobileNavigationReducer from "./mobileNavigation";
import reportViewSettings from "./reportViewSettings";
import settingsMenuReducer from "./settingsMenu";
import tenantDetailsReducer from "./tenantDetails";
import themeReducer from "./theme";
import trackingSummaryReducer from "./trackingSummary";
import userReducer from "./user";
import workflowReducer from "./workflow";
import workflowTemplateReducer from "./workflowTemplates";

export const rootReducer = combineReducers({
    applicationReducer,
    userReducer,
    languageReducer,
    themeReducer,
    licensesReducer,
    tenantDetailsReducer,
    reportViewSettings,
    workflowReducer,
    workflowTemplateReducer,
    bmcEolReducer,
    trackingSummaryReducer,
    assetViewsReducer,
    settingsMenuReducer,
    mobileNavigationReducer,
});

export type createStore = ReturnType<typeof rootReducer>;

export type StoreState = ReturnType<typeof rootReducer>;

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV === "development",
});
